var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_2107",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 41
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H41V41H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_2107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.486 40.3993V36.7157C26.486 33.7462 24.465 31.1577 21.5842 30.4375L16.779 29.2362H10.3077L5.50241 30.4375C2.6216 31.1577 0.600586 33.7462 0.600586 36.7157V40.3993H26.486Z",
    fill: "#F7E365"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9112 40.3994H13.543V38.6198C13.543 38.173 13.9052 37.8109 14.3519 37.8109H17.1022C17.549 37.8109 17.9112 38.173 17.9112 38.6198V40.3994Z",
    fill: "#E175A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.13672 34.1377L3.26431 36.2653C3.58022 36.5812 4.0924 36.5812 4.40823 36.2653L7.84022 32.8333C8.15613 32.5174 8.15613 32.0053 7.84022 31.6893L6.37127 30.2204L5.50242 30.4376C3.50391 30.9372 1.91996 32.3364 1.13672 34.1377Z",
    fill: "#E175A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.13672 34.1377L3.26431 36.2653C3.58022 36.5812 4.0924 36.5812 4.40823 36.2653L7.84022 32.8333C8.15613 32.5174 8.15613 32.0053 7.84022 31.6893L6.37127 30.2204",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5842 30.4376L19.6831 29.9624C21.8339 31.0418 23.2503 33.2596 23.2503 35.745V40.3994H26.486V36.7157C26.486 33.7463 24.465 31.1578 21.5842 30.4376Z",
    fill: "#F3D332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5433 32.472C11.7562 32.472 10.3076 31.0234 10.3076 29.2363V25.5153H16.7789V29.2363C16.7789 31.0234 15.3303 32.472 13.5433 32.472Z",
    fill: "#FFBD86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.779 26.9011V29.2363C16.779 31.0233 15.3304 32.4719 13.5433 32.4719C11.7563 32.4719 10.3076 31.0233 10.3076 29.2363V26.901",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.18213 39.1941V40.3994",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9048 39.1941V40.3994",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7788 29.2365L21.5843 30.4377C24.3654 31.1328 26.3449 33.5695 26.4787 36.4091",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4858 39.2116V40.3992H0.600586V36.7156C0.600586 33.7463 2.62176 31.1574 5.50217 30.4375L10.3077 29.2363",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81982 32.8536L8.51939 33.5532",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07129 34.602L6.77085 35.3015",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33936 36.3346L5.03892 37.0341",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9316 36.8215V37.8109",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.481 36.8215V37.8109",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.543 40.3994V38.6198C13.543 38.173 13.9051 37.8109 14.3519 37.8109H17.1022C17.549 37.8109 17.9112 38.173 17.9112 38.6198V40.3994",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4541 10.7929V18.1541C5.4541 22.6217 9.07579 26.2433 13.5433 26.2433C18.0108 26.2433 21.6324 22.6217 21.6324 18.1541V10.7929H5.4541Z",
    fill: "#FED2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4418 18.1542H21.6328V13.3007H22.4418C23.782 13.3007 24.8685 14.3871 24.8685 15.7274C24.8685 17.0677 23.782 18.1542 22.4418 18.1542Z",
    fill: "#FED2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4418 18.1542H21.6328V13.3007H22.4418C23.782 13.3007 24.8685 14.3871 24.8685 15.7274C24.8685 17.0677 23.782 18.1542 22.4418 18.1542Z",
    fill: "#FED2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64503 18.1542H5.45398V13.3007H4.64503C3.30476 13.3007 2.21826 14.3871 2.21826 15.7274C2.21826 17.0677 3.30476 18.1542 4.64503 18.1542Z",
    fill: "#FED2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64503 18.1542H5.45398V13.3007H4.64503C3.30476 13.3007 2.21826 14.3871 2.21826 15.7274C2.21826 17.0677 3.30476 18.1542 4.64503 18.1542Z",
    fill: "#FED2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2054 18.1541C19.2054 19.3179 18.8522 20.4005 18.2478 21.3011C18.0207 20.928 17.6114 20.678 17.1427 20.678C16.9866 20.678 16.8377 20.707 16.6992 20.7576C16.4622 19.9532 15.7185 19.3658 14.8372 19.3658C14.3399 19.3658 13.8865 19.553 13.543 19.8606C13.1995 19.553 12.7461 19.3658 12.2487 19.3658C11.3674 19.3658 10.6238 19.9532 10.3867 20.7576C10.2482 20.707 10.0993 20.678 9.94326 20.678C9.47456 20.678 9.06528 20.928 8.83818 21.3011C8.23375 20.4005 7.88052 19.3179 7.88052 18.1541V13.3815C7.88052 11.6828 9.9837 11.6828 9.9837 11.6828C9.49834 13.3007 10.7118 14.514 10.7118 14.514C11.1971 12.0873 13.543 11.521 13.543 11.521C13.1385 13.1388 14.4328 14.3522 14.4328 14.3522C14.8372 10.793 18.0729 10.793 18.0729 10.793L19.2054 13.3815V18.1541ZM23.25 10.3076C23.25 4.94661 18.904 0.600613 13.543 0.600613C8.18194 0.600613 3.83594 4.94653 3.83594 10.3076V13.5433H5.45376V18.1541C5.45376 19.8033 5.94768 21.3368 6.79498 22.6157C6.62498 22.8718 6.52544 23.1788 6.52544 23.5093C6.52544 24.3273 7.13323 25.0018 7.92152 25.1101C7.90439 25.194 7.89542 25.2809 7.89542 25.3697C7.89542 26.0846 8.47486 26.664 9.18964 26.664C9.48145 26.664 9.74971 26.5663 9.96624 26.4035C10.1812 26.8201 10.615 27.1055 11.1162 27.1055C11.4101 27.1055 11.6803 27.0064 11.8976 26.8413C12.2409 27.3885 12.8492 27.7526 13.543 27.7526C14.2367 27.7526 14.845 27.3885 15.1884 26.8413C15.4056 27.0064 15.6758 27.1055 15.9698 27.1055C16.471 27.1055 16.9048 26.8201 17.1198 26.4035C17.3362 26.5663 17.6045 26.664 17.8963 26.664C18.6112 26.664 19.1905 26.0846 19.1905 25.3697C19.1905 25.2809 19.1816 25.194 19.1645 25.1101C19.9528 25.0018 20.5606 24.3273 20.5606 23.5093C20.5606 23.1788 20.461 22.8718 20.291 22.6157C21.1383 21.3368 21.6322 19.8033 21.6322 18.1541V13.5433H23.25V10.3076Z",
    fill: "#C7865B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9625 2.25311C19.795 4.64776 19.4108 7.84296 17.774 10.8162C17.9602 10.793 18.0731 10.793 18.0731 10.793L19.1754 13.3125L19.2056 13.3815V18.1541C19.2056 19.3178 18.8524 20.4005 18.248 21.3011C18.1321 21.1108 17.9686 20.9528 17.7743 20.8433C17.1801 21.9164 16.4026 22.9576 15.4503 23.9099C13.9936 25.3666 12.3287 26.4149 10.6602 27.0222C10.8021 27.0758 10.9556 27.1054 11.1164 27.1054C11.4102 27.1054 11.6804 27.0063 11.8978 26.8412C12.2411 27.3885 12.8494 27.7526 13.5431 27.7526C14.2368 27.7526 14.8452 27.3885 15.1886 26.8412C15.4058 27.0063 15.676 27.1054 15.97 27.1054C16.4712 27.1054 16.9049 26.82 17.1199 26.4034C17.3364 26.5663 17.6047 26.664 17.8964 26.664C18.6113 26.664 19.1907 26.0845 19.1907 25.3697C19.1907 25.2808 19.1817 25.194 19.1646 25.1101C19.953 25.0018 20.5607 24.3273 20.5607 23.5092C20.5607 23.1787 20.4612 22.8717 20.2911 22.6157C21.1385 21.3367 21.6323 19.8032 21.6323 18.1541V13.5432H23.2502V10.3076C23.2502 6.95353 21.549 3.99681 18.9625 2.25311Z",
    fill: "#B36D3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4541 18.1541C5.4541 19.8033 5.94802 21.3368 6.79533 22.6157C6.62524 22.8718 6.52571 23.1788 6.52571 23.5093C6.52571 24.3273 7.1335 25.0018 7.92179 25.1101C7.90473 25.194 7.89568 25.2809 7.89568 25.3697C7.89568 26.0846 8.47521 26.664 9.18999 26.664C9.48171 26.664 9.75005 26.5663 9.9665 26.4035C10.1815 26.8201 10.6153 27.1055 11.1164 27.1055C11.4104 27.1055 11.6806 27.0064 11.8979 26.8413C12.2412 27.3885 12.8496 27.7526 13.5433 27.7526C14.237 27.7526 14.8453 27.3885 15.1886 26.8413C15.406 27.0064 15.6762 27.1055 15.9701 27.1055C16.4713 27.1055 16.905 26.8201 17.12 26.4035C17.3366 26.5663 17.6048 26.664 17.8966 26.664C18.6114 26.664 19.1909 26.0846 19.1909 25.3697C19.1909 25.2809 19.1819 25.194 19.1648 25.1101C19.9531 25.0018 20.5608 24.3273 20.5608 23.5093C20.5608 23.1788 20.4613 22.8718 20.2912 22.6157C21.1386 21.3368 21.6324 19.8033 21.6324 18.1541",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3994 22.765C12.6923 22.4721 13.0967 22.291 13.5433 22.291C13.9898 22.291 14.3942 22.4721 14.687 22.765",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6023 16.8324C24.4866 17.0589 24.3354 17.2651 24.1574 17.4432C23.7181 17.8824 23.1115 18.1542 22.4418 18.1542H21.6328V13.3006H22.2354",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45398 13.3007H4.64503C3.30476 13.3007 2.21826 14.3872 2.21826 15.7274C2.21826 17.0677 3.30476 18.1541 4.64503 18.1541H5.45398V13.3007Z",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83594 13.3815V10.3077C3.83594 4.9469 8.18226 0.600662 13.5429 0.600662C16.2237 0.600662 18.6505 1.687 20.4067 3.444C21.2261 4.26263 21.8991 5.22766 22.3844 6.29542",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.88037 17.5779V18.1545C7.88037 19.318 8.23432 20.4007 8.83811 21.3008C9.06553 20.9284 9.47473 20.6778 9.94318 20.6778C10.0993 20.6778 10.2483 20.7074 10.3868 20.7579C10.6238 19.9531 11.3678 19.3661 12.2486 19.3661C12.7459 19.3661 13.2 19.5527 13.5435 19.8602C13.887 19.5527 14.3403 19.3661 14.8376 19.3661C15.7184 19.3661 16.4623 19.9531 16.6994 20.7579C16.8379 20.7074 16.9869 20.6778 17.143 20.6778C17.6115 20.6778 18.0207 20.9284 18.2481 21.3008C18.8527 20.4007 19.2058 19.318 19.2058 18.1545V13.3819L18.0735 10.7929C18.0735 10.7929 14.8376 10.7929 14.4332 14.3524C14.4332 14.3524 13.1391 13.1392 13.5435 11.5208C13.5435 11.5208 11.1972 12.087 10.7119 14.5142C10.7119 14.5142 9.49875 13.301 9.98402 11.6826C9.98402 11.6826 7.88037 11.6826 7.88037 13.3819L7.88037 14.7752",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09968 8.05175C4.09968 8.05175 3.83606 9.18293 2.5874 9.33099",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91543 2.39755C7.91543 2.39755 6.60247 3.52121 4.24609 3.15493",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7875 23.1494C30.7875 24.0429 30.0632 24.7672 29.1696 24.7672C28.2761 24.7672 27.5518 24.0429 27.5518 23.1494C27.5518 22.2559 28.2761 21.5316 29.1696 21.5316C30.0632 21.5316 30.7875 22.2559 30.7875 23.1494Z",
    fill: "#B2E5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9767 26.0615C25.9767 26.7762 25.3973 27.3558 24.6824 27.3558C23.9676 27.3558 23.3882 26.7762 23.3882 26.0615C23.3882 25.3467 23.9676 24.7672 24.6824 24.7672C25.3973 24.7672 25.9767 25.3467 25.9767 26.0615Z",
    fill: "#91DAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7875 23.1494C30.7875 24.0429 30.0632 24.7672 29.1696 24.7672C28.2761 24.7672 27.5518 24.0429 27.5518 23.1494C27.5518 22.2559 28.2761 21.5316 29.1696 21.5316C30.0632 21.5316 30.7875 22.2559 30.7875 23.1494Z",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3998 9.98399C40.3998 4.80166 36.1986 0.600519 31.0163 0.600519C25.834 0.600519 21.6328 4.80166 21.6328 9.98399C21.6328 13.48 23.545 16.5293 26.3802 18.1436C26.3451 18.2762 26.3246 18.4149 26.3246 18.5585C26.3246 19.452 27.0489 20.1764 27.9424 20.1764C28.1478 20.1764 28.3434 20.1366 28.5242 20.0668C28.8294 21.1566 29.8291 21.956 31.0163 21.956C32.2034 21.956 33.2032 21.1566 33.5085 20.0668C33.6892 20.1366 33.8848 20.1764 34.0902 20.1764C34.9837 20.1764 35.7081 19.452 35.7081 18.5585C35.7081 18.4149 35.6875 18.2762 35.6523 18.1436C38.4877 16.5293 40.3998 13.48 40.3998 9.98399Z",
    fill: "#E6F7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3994 9.98399C40.3994 7.4677 39.4088 5.18283 37.7965 3.49782C38.3001 6.85566 36.8175 10.9619 33.6036 14.1758C31.4273 16.3521 28.8417 17.7344 26.3565 18.2438C26.3357 18.3456 26.3242 18.4506 26.3242 18.5585C26.3242 19.452 27.0485 20.1764 27.942 20.1764C28.1474 20.1764 28.343 20.1366 28.5238 20.0668C28.829 21.1566 29.8288 21.956 31.0159 21.956C32.2031 21.956 33.2028 21.1566 33.5081 20.0668C33.6888 20.1366 33.8845 20.1764 34.0899 20.1764C34.9833 20.1764 35.7077 19.452 35.7077 18.5585C35.7077 18.4149 35.6871 18.2762 35.652 18.1436C38.4873 16.5293 40.3994 13.48 40.3994 9.98399Z",
    fill: "#D3EFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3288 14.3404C40.0127 13.0383 40.3994 11.5569 40.3994 9.98413C40.3994 4.80148 36.1985 0.600579 31.0159 0.600579C25.834 0.600579 21.6323 4.80148 21.6323 9.98413C21.6323 13.4803 23.5446 16.5289 26.3802 18.1433C26.3449 18.2762 26.3241 18.4148 26.3241 18.5589C26.3241 19.4518 27.0488 20.1765 27.9417 20.1765C28.1475 20.1765 28.3429 20.1364 28.5238 20.0668C28.8289 21.1566 29.8291 21.9558 31.0159 21.9558C32.2034 21.9558 33.2028 21.1566 33.5079 20.0668C33.6889 20.1364 33.8843 20.1765 34.0901 20.1765C34.9838 20.1765 35.7077 19.4518 35.7077 18.5589C35.7077 18.4148 35.6868 18.2762 35.6516 18.1433C36.3939 17.7205 37.0722 17.2 37.6704 16.5986",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9767 26.0615C25.9767 26.7762 25.3973 27.3558 24.6824 27.3558C23.9676 27.3558 23.3882 26.7762 23.3882 26.0615C23.3882 25.3467 23.9676 24.7672 24.6824 24.7672C25.3973 24.7672 25.9767 25.3467 25.9767 26.0615Z",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.029 14.0322V8.81121L31.016 3.79824L26.0029 8.81121V14.0322H36.029Z",
    fill: "#FED2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5615 14.0322H36.4699",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9945 9.77661L31.016 3.79814L25.0376 9.77661",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0288 14.0322V8.81121",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0029 8.81121V14.0322",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3102 11.8144C32.3102 11.0996 31.7308 10.5201 31.0159 10.5201C30.3011 10.5201 29.7217 11.0996 29.7217 11.8144V14.0322H32.3102V11.8144Z",
    fill: "#C57A44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3102 11.8144C32.3102 11.0996 31.7308 10.5201 31.0159 10.5201C30.3011 10.5201 29.7217 11.0996 29.7217 11.8144V14.0322H32.3102V11.8144Z",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.207 7.95282H31.8248",
    stroke: "black",
    strokeWidth: 1.20117,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.c8961ddb5d2f0d2157db4dac73b1afcc.svg";
export { ForwardRef as ReactComponent };